// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"Y4-z","colorTextValue":"Z4-z","swatches":"_4-z","collapseLink":"a5-z","isCollapsed":"b5-z","dropdown":"c5-z","disabled":"d5-z"};